export { default as QRCode } from './qrcode/qrcode';
export { default as qrcodeValidator } from './qrcode/qrcode-validator';